import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Raven from 'raven-js';
import moment from 'moment';
import { alphanumericwithspace } from '../../modules/validator';
import { Timeline } from 'antd';
import { Radio } from 'antd';
import reduxStore from '../../store';
import SideBar from '../../components/sidebar/sidebar';
import Header from '../../components/header/header';
import { Row, Col, Table, Divider, Icon, Drawer,Form, Input, Modal, message, Breadcrumb, Button, Tooltip, notification, Select } from 'antd';
import * as processingOrderActions from '../../actions/data/processingOrder';
import * as partyActions from '../../actions/data/party';
import * as receiptActions from '../../actions/data/receipt';
import './processingOrder.scss';

const history = reduxStore.history;
const confirm = Modal.confirm;
const FormItem = Form.Item;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message,
    description
  });
};
class ProcessingOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfPossibleItems : 5,
      visible: false,
      partysData: [],
      receiptsData: [],
      processingOrdersData: [],
      createProcessingOrderVisible: false,
      currentRow: {},
      editedprocessingId: '',
      processingOrderdEdited: false,
      dropdownFilter: '',
      editClicked: false,
      updated: false,
    };
    this.onChange = this.onChange.bind(this);
    this.showDrawer = this.showDrawer.bind(this);
    this.onClose = this.onClose.bind(this);
    this.showConfirm = this.showConfirm.bind(this);
    this.createProcessingOrderShowDrawer = this.createProcessingOrderShowDrawer.bind(this);
    this.onCreateProcessingOrderClose = this.onCreateProcessingOrderClose.bind(this);
    this.handleCreateProcessingOrder = this.handleCreateProcessingOrder.bind(this);
    this.onTableRowClick = this.onTableRowClick.bind(this);
    this.handleUpdateProcessingOrder = this.handleUpdateProcessingOrder.bind(this);
    this.handleDropDownSearch = this.handleDropDownSearch.bind(this);
    this.showViewDrawer = this.showViewDrawer.bind(this);
    this.onViewClose = this.onViewClose.bind(this);
  }
  componentDidMount() {
    document.title = "MRC Fabrics | ProcessingOrders";
    const newMaxHeight = window.innerHeight - 330;
    const possibleRows = Math.ceil(newMaxHeight/54);
    if(possibleRows > this.state.numberOfPossibleItems) {
      this.setState({numberOfPossibleItems: possibleRows});
    }
    // if(this.props.user.loginSuccess) {
    //   message.success('Logged in successfully!', 3);
    // }
    let userToken = null;
    this.props.actions.getProcessingOrders(userToken);
    this.props.actions.getParty(userToken);
    this.props.actions.getReceipts(userToken);
  }
  static getDerivedStateFromProps(nextProps, currentProps) {
    console.log( nextProps)
    let userToken = null;
    // if(this.props.user.response && this.props.user.response.token) {
    //     userToken = this.props.user.response.token;
    // } else {
    //     userToken = localStorage.getItem('_token');
    // }
    if(nextProps.partys && nextProps.partys.getPartySuccess) {
      nextProps.partys.getPartySuccess = false;
      return {
        partysData: nextProps.partys.data.listPartyDTO.map(data => {data.key = data.partyId; return data})
      }
    }
    if(nextProps.receipts && nextProps.receipts.getReceiptsSuccess) {
      nextProps.receipts.getReceiptsSuccess = false;
      return {
        receiptsData: nextProps.receipts.data.listReciptDTO.map(data => {data.key = data.receiptId; return data})
      }
    }
    if(nextProps.processingOrders && nextProps.processingOrders.getProcessingOrdersSuccess) {
      nextProps.processingOrders.getProcessingOrdersSuccess = false;
      return {
        updated: true, 
        processingOrdersData: nextProps.processingOrders.data.listProcessingDTO.map(data => {data.key = data.processingId; return data})
      }
    }
    if(nextProps.processingOrders && nextProps.processingOrders.createProcessingOrderSuccess && !nextProps.processingOrders.createProcessingOrderPending) {
      nextProps.processingOrders.createProcessingOrderSuccess = false;
      nextProps.actions.getProcessingOrders(userToken);
      nextProps.form.resetFields();
      message.success('ProcessingOrder created successfully!', 2);
      return {
        updated: false,
        currentRow: {},
        createProcessingOrderVisible: false
      };
    }
     if(nextProps.processingOrders && nextProps.processingOrders.updateProcessingOrderSuccess && !nextProps.processingOrders.updateProcessingOrderPending) {
      nextProps.processingOrders.updateProcessingOrderSuccess  = false;
      nextProps.actions.getProcessingOrders(userToken);
      nextProps.form.resetFields();
      message.success('ProcessingOrder edited successfully!', 2);
      return {
        visible: false,
        editClicked: false,
        currentRow: {},
        processingOrderdEdited: true,
        updated: false
      };
  }
  if(nextProps.processingOrders && nextProps.processingOrders.deleteProcessingOrderSuccess && !nextProps.processingOrders.deleteProcessingOrderPending) {
    nextProps.processingOrders.deleteProcessingOrderSuccess = false;  
    nextProps.actions.getProcessingOrders(userToken);
    message.success('ProcessingOrder deleted successfully!', 2);
    return {
      currentRow: '',
      updated: false
    };
    }
    if(nextProps.processingOrders && nextProps.processingOrders.error) {
      if(nextProps.processingOrders.error.message)
        message.error(nextProps.processingOrders.error.message,2);
        nextProps.processingOrders.error = {};
      //   Raven.setExtraContext({
      //       props: this.props
      //   });
      // Raven.captureException(nextProps.processingOrders.error.message, { extra: nextProps });
      if(nextProps.processingOrders.error.message === "Failed to fetch") {
        openNotificationWithIcon("error", "It looks like you've lost your internet connection", "But you probably already knew that! This must be frustrating, Don't leave us, we track these things and resume automatically! Until then just relax!! ");           
      }
    }
  return null;
    
   
    
}
  handleDropDownSearch(dropdownFilter) {
    if(!dropdownFilter)
      dropdownFilter='';
    this.setState({dropdownFilter});
  }
  onTableRowClick(currentRow) {
    this.setState({currentRow,processingOrderdEdited: false, editedprocessingId: ''});
  }
  showConfirm() {
    let userToken = null;
    // if(this.props.user.response && this.props.user.response.token) {
    //     userToken = this.props.user.response.token;
    // } else {
    //     userToken = localStorage.getItem('_token');
    // }
    const deleteProcessingOrder = () => {
      this.props.actions.deleteProcessingOrder(this.state.currentRow.processingId, userToken);
    } 
    const resetFields = () => {
      this.setState({currentRow: ''});
    }
    confirm({
      title: 'Are you sure delete this ProcessingOrder?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteProcessingOrder();
      },
      onCancel() {
        resetFields();
        console.log('Cancel');
      },
    });
  }
  onChange(pagination, filters, sorter) {
    console.log('params', pagination, filters, sorter);
  }  
  onViewClose (){
    this.setState({
      viewVisible: false,
      currentRow: ''
    });
  }
  showViewDrawer (){
    this.setState({
      viewVisible: true,
    });
  }
  createProcessingOrderShowDrawer = () => {
    this.props.form.resetFields();
    this.setState({
      createProcessingOrderVisible: true,
    });
  };

  onCreateProcessingOrderClose = () => {
    this.props.form.resetFields();
    this.setState({
      createProcessingOrderVisible: false,
    });
  };
  handleCreateProcessingOrder = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let userToken = null;
        // if(this.props.user.response && this.props.user.response.token) {
        //     userToken = this.props.user.response.token;
        // } else {
        //     userToken = localStorage.getItem('_token');
        // }
        values.partyId = parseInt(values.partyId,10);
        values.reciptId = parseInt(values.reciptId, 10);
        values.totalKgs = parseInt(values.totalKgs,10);
        values.totalBundles = parseFloat(values.totalBundles,10);
        this.props.actions.createProcessingOrder(values, userToken);
      }
    });
  }
  handleUpdateProcessingOrder = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let userToken = null;
        // if(this.props.user.response && this.props.user.response.token) {
        //     userToken = this.props.user.response.token;
        // } else {
        //     userToken = localStorage.getItem('_token');
        // }
        values.partyId = parseInt(values.partyId,10);
        values.reciptId = parseInt(values.reciptId, 10);
        values.totalKgs = parseInt(values.totalKgs,10);
        values.totalBundles = parseFloat(values.totalBundles,10);
        this.setState({editedprocessingId: this.state.currentRow.processingId});
        this.props.actions.updateProcessingOrder(this.state.currentRow.processingId, values, userToken);
      }
    });
  }
  showDrawer (){
    this.props.form.resetFields();
    this.setState({
      visible: true,
      editClicked: true
    });
  }
  onClose (){
    this.setState({
      visible: false,
      editClicked: false,
      currentRow: {}
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const columns = [{
      title: 'Party',
      dataIndex: 'partyId',
      sorter: (a, b) => { return a.partyId.localeCompare(b.partyId)}
    }, {
      title: 'StockFrom',
      dataIndex: 'stockFrom',
      sorter: (a, b) => { return a.stockFrom.localeCompare(b.stockFrom)},
      render: (text, record) => {
        if(text && text.length > 50) {
          return text.substring(0,50)+'...';
        } else {
          return text;
        }
      }
    }, {
      title: 'JobDetails',
      dataIndex: 'jobDetails',
      sorter: (a, b) => { return a.jobDetails.localeCompare(b.jobDetails)}
    },
    {
      title: 'TotalKgs',
      dataIndex: 'totalKgs',
      sorter: (a, b) => { return a.totalKgs.localeCompare(b.totalKgs)},
    },
    {
      title: 'Action',
      key: 'action',
      width: 240,
      render: (text, record) => (
        <span>
         <Tooltip title="View ProcessingOrder">
            <span onClick={this.showViewDrawer} className="cursor-pointer"><Icon type="eye" /> View</span>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip title="Edit ProcessingOrder">
            <span onClick={this.showDrawer} className="cursor-pointer"><Icon type="edit" /> Edit</span>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip title="Delete ProcessingOrder">
            <span  onClick={this.showConfirm} className="cursor-pointer"><Icon type="delete" /> Delete</span>
          </Tooltip>
          {record.idprocessingOrder === this.state.editedprocessingId && this.state.processingOrderdEdited ? <span className={"success"} style={{fontSize: 11,paddingLeft: 10,color: 'green'}}>updated!</span> : null}
        </span>
      )
    }];
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return(
      <Row>
        <Col 
          xs={6} 
          sm={6}
          md={4}
          lg={4}
          xl={4}
          className="height-100">
          <SideBar changePath={history.push} {...history}/>
        </Col>
        <Col
          xs={18} 
          sm={18}
          md={20}
          lg={20}
          xl={20} className="height-100-55 dashboard">
            <Row>
              <Header />
              <Row className="contents-main">
                    <div className="breadcrumb-div">
                    <Breadcrumb>
                      <Breadcrumb.Item>Home</Breadcrumb.Item>
                      <Breadcrumb.Item>ProcessingOrder</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="add-processingOrder-button">
                        <Button type="primary" className="login-form-button" style = {{
                          width: 220,
                          float: 'right',
                          marginTop: -30
                        }}onClick={this.createProcessingOrderShowDrawer}>
                        <Icon type="plus" /> Add Processing Order
                        </Button>
                    </div>
                    </div>
                    <div className="main-table-div">
                      <Table 
                        className="main-table" 
                        columns={columns} 
                        dataSource={this.state.processingOrdersData} 
                        pagination={{pageSize:this.state.numberOfPossibleItems}} 
                        loading={this.state.processingOrdersData.length === 0&& !this.state.updated}
                        locale={{ emptyText: 'No processingOrders added!' }}
                        onChange={this.onChange} onRow={(record, index) => ({
                          onClick: (event) => { this.onTableRowClick(record); } 
                      })}/>
                    </div>
                </Row>
                <Drawer
                  title="Add ProcessingOrder"
                  placement="right"
                  closable={false}
                  onClose={this.onCreateProcessingOrderClose}
                  visible={this.state.createProcessingOrderVisible}
                  width={450}
                >
                  <Form onSubmit={this.handleCreateProcessingOrder} className="processingOrder-create" id="createProcessingOrder">
                        <FormItem
                            {...formItemLayout}
                            label="Party"
                            >
                            {getFieldDecorator('partyId', {
                                rules: [{ required: true, message: 'Please select party!'}],
                            })(
                              <Select 
                                style={{ width: "100%" }}
                              >
                                {(this.state.partysData.length)? 
                                  this.state.partysData.map(party => 
                                  <Option value={party.partyId.toString()} key={'party'+party.partyId}>{party.partyName}</Option>
                                  ): ''}
                            </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Receipt"
                            >
                            {getFieldDecorator('receiptId', {
                                rules: [{ required: true, message: 'Please select receipt!'}],
                            })(
                              <Select 
                                style={{ width: "100%" }}
                              >
                                {(this.state.receiptsData.length)? 
                                  this.state.receiptsData.map(receipt => 
                                  <Option value={receipt.reciptId.toString()} key={'receipt'+receipt.reciptId}>{receipt.reciptId}</Option>
                                  ): ''}
                            </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Stock From"
                            >
                            {getFieldDecorator('stockFrom', {
                                rules: [{ required: true, message: 'Please enter Stock From!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Job Details"
                            >
                            {getFieldDecorator('jobDetails', {
                                rules: [{ required: true, message: 'Please enter jobDetails!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Items"
                            >
                            {getFieldDecorator('itemsForProcessing', {
                                rules: [{ required: true, message: 'Please enter itemsForProcessing!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="TotalKgs"
                            >
                            {getFieldDecorator('totalKgs', {
                                rules: [{ required: true, message: 'Please enter totalKgs', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Total Bundles"
                            >
                            {getFieldDecorator('totalBundles', {
                                rules: [{ required: true, message: 'Please enter totalBundles!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Processing Status"
                            >
                            {getFieldDecorator('ProcessingStatus', {
                                rules: [{ required: true, message: 'Please enter ProcessingStatus!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <br/><br/><br/>
                        <div
                            style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            borderTop: '1px solid #e8e8e8',
                            padding: '10px 16px',
                            textAlign: 'right',
                            left: 0,
                            background: '#fff',
                            borderRadius: '0 0 4px 4px',
                            }}
                        >
                            <FormItem {...tailFormItemLayout} className="submit-buttons-edit-profile">
                                <Button type="primary" htmlType="submit">Create</Button>
                                <Button type="default" className="edit-profile-cancel" onClick={this.onCreateProcessingOrderClose}>Cancel</Button>
                            </FormItem>
                        </div>
                        </Form>
                </Drawer>
            <Drawer
                title="Edit ProcessingOrder"
                placement="right"
                closable={false}
                onClose={this.onClose}
                visible={this.state.visible}
                width={450}
              >
              <Form onSubmit={this.handleUpdateProcessingOrder} className="processingOrder-create" id="updateProcessingOrder">
                        <FormItem
                            {...formItemLayout}
                            label="Supplier"
                            >
                            {getFieldDecorator('partyId', {
                                rules: [{ required: true, message: 'Please select supplier!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.partyId : null
                            })(
                              <Select 
                                style={{ width: "100%" }}
                              >
                                {(this.state.partysData.length)? 
                                  this.state.partysData.map(party => 
                                  <Option value={party.partyId.toString()} key={'party'+party.partyId}>{party.partyName}</Option>
                                  ): ''}
                            </Select>
                            )}
                        </FormItem>
                              <FormItem
                            {...formItemLayout}
                            label="Receipt"
                            >
                            {getFieldDecorator('receiptId', {
                                rules: [{ required: true, message: 'Please select receipt ID!'}],
                                initialValue: this.state.editClicked ? this.state.currentRow.reciptId : null
                            })(
                              <Select 
                                style={{ width: "100%" }}
                              >
                                {(this.state.receiptsData.length)? 
                                  this.state.receiptsData.map(receipt => 
                                  <Option value={receipt.reciptId.toString()} key={'receipt'+receipt.reciptId}>{receipt.reciptId}</Option>
                                  ): ''}
                            </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Stock From"
                            >
                            {getFieldDecorator('stockFrom', {
                                rules: [{ required: true, message: 'Please enter stockFrom', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.stockFrom : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Job Details"
                            >
                            {getFieldDecorator('jobDetails', {
                                rules: [{ required: true, message: 'Please enter jobDetails!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.jobDetails : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Items"
                            >
                            {getFieldDecorator('itemsForProcessing', {
                                rules: [{ required: true, message: 'Please enter processingOrder itemsForProcessing!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.itemsForProcessing : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="TotalKgs"
                            >
                            {getFieldDecorator('totalKgs', {
                                rules: [{ required: true, message: 'Please enter totalKgs!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.totalKgs : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Total Bundles"
                            >
                            {getFieldDecorator('totalBundles', {
                                rules: [{ required: true, message: 'Please enter totalBundles!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.totalBundles : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Processing Status"
                            >
                            {getFieldDecorator('ProcessingStatus', {
                                rules: [{ required: true, message: 'Please enter ProcessingStatus!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.ProcessingStatus : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <br/><br/><br/>
                        <div
                            style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            borderTop: '1px solid #e8e8e8',
                            padding: '10px 16px',
                            textAlign: 'right',
                            left: 0,
                            background: '#fff',
                            borderRadius: '0 0 4px 4px',
                            }}
                        >
                            <FormItem {...tailFormItemLayout} className="submit-buttons-edit-profile">
                                <Button type="primary" htmlType="submit">Update</Button>
                                <Button type="default" className="edit-profile-cancel" onClick={this.onClose}>Cancel</Button>
                            </FormItem>
                        </div>
                        </Form>
              </Drawer>
              <Drawer
                title="View ProcessingOrder"
                placement="right"
                closable={false}
                onClose={this.onViewClose}
                visible={this.state.viewVisible}
                width={500}
              >
                    
                    <p>Party : {this.state.currentRow.partyId ? <b>{this.state.currentRow.partyId}</b> : 'Not Provided.'}</p>
                    <p>Stock From : {this.state.currentRow.stockFrom ? <b>{this.state.currentRow.stockFrom}</b> : 'Not Provided.'}</p>
                    <p>Recipt: {this.state.currentRow.reciptId ? <b>{this.state.currentRow.reciptId}</b> : 'Not Provided.'}</p>
                    <p>Job Details : {this.state.currentRow.jobDetails ? <b>{this.state.currentRow.jobDetails}</b> : 'Not Provided.'}</p>
                    <p>Items : {this.state.currentRow.itemsForProcessing ? <b>{this.state.currentRow.itemsForProcessing}</b> : 'Not Provided.'}</p>
                    <p>Total Kgs : {this.state.currentRow.totalKgs ? <b>{this.state.currentRow.totalKgs}</b> : 'Not Provided.'}</p>
                    <p>Total Bundles: {this.state.currentRow.totalBundles ? <b>{this.state.currentRow.totalBundles}</b> : 'Not Provided.'}</p>
                    <p>Processing Status : {this.state.currentRow.ProcessingStatus ? <b>{this.state.currentRow.ProcessingStatus}</b> : 'Not Provided.'}</p>
                    
              </Drawer>
            </Row>
        </Col>
      </Row>
    );
  }
}
const WrappedProcessingOrder = Form.create()(ProcessingOrder);
function mapStateToProps(state) {
  return {
    user: state.user,
    processingOrders: state.processingOrder,
    partys: state.party,
    receipts: state.receipt
  };
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(Object.assign({}, processingOrderActions, partyActions, receiptActions), dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedProcessingOrder)